import React from "react";
import styled from "styled-components";
import { ColorBgGray, ColorDarkBlack, ColorMainBlue } from "../../Utiles/Color";
import { Container, Text } from "../../Assets/css/common";
import img_partner1 from "../../Assets/images/partner_logo01.png";
import img_partner2 from "../../Assets/images/partner_logo02.png";
import img_partner4 from "../../Assets/images/partner_logo04.png";
import img_partner5 from "../../Assets/images/partner_logo05.png";
import img_partner6 from "../../Assets/images/partner_logo06.png";
import img_partner7 from "../../Assets/images/partner_logo07.png";
import img_partner8 from "../../Assets/images/partner_logo08.png";
import img_partner9 from "../../Assets/images/partner_logo09.png";
import img_partner11 from "../../Assets/images/partner_logo11.png";
import img_partner12 from "../../Assets/images/partner_logo12.png";
import img_partner13 from "../../Assets/images/partner_logo13.png";
import img_partner14 from "../../Assets/images/partner_logo14.png";
import img_partner15 from "../../Assets/images/partner_logo15.png";
import img_partner16 from "../../Assets/images/partner_logo16.png";
import img_partner17 from "../../Assets/images/partner_logo17.png";
import img_partner18 from "../../Assets/images/partner_logo18.png";
import img_partner19 from "../../Assets/images/partner_logo19.png";
import img_partner21 from "../../Assets/images/partner_logo21.png";
import img_partner22 from "../../Assets/images/partner_logo22.png";
import img_partner23 from "../../Assets/images/partner_logo23.png";
import img_partner24 from "../../Assets/images/partner_logo24.png";
import img_partner25 from "../../Assets/images/partner_logo25.png";
import img_partner26 from "../../Assets/images/partner_logo26.png";
import img_partner27 from "../../Assets/images/partner_logo27.png";
import img_partner28 from "../../Assets/images/partner_logo28.png";
import img_partner29 from "../../Assets/images/partner_logo29.png";
import img_partner30 from "../../Assets/images/partner_logo30.png";
import img_partner31 from "../../Assets/images/partner_logo31.png";

const partnerLogos = [
  img_partner1,
  img_partner2,
  img_partner4,
  img_partner5,
  img_partner6,
  img_partner7,
  img_partner8,
  img_partner9,
  img_partner11,
  img_partner12,
  img_partner13,
  img_partner14,
  img_partner15,
  img_partner16,
  img_partner17,
  img_partner18,
  img_partner19,
  img_partner21,
  img_partner22,
  img_partner23,
  img_partner24,
  img_partner25,
  img_partner26,
  img_partner27,
  img_partner28,
  img_partner29,
  img_partner30,
  img_partner31,
];

function MainPartner() {
  return (
    <>
      <Wrapper>
        <Container>
          <Text
            as="h3"
            color={ColorDarkBlack}
            weight={"700"}
            align={"center"}
            className="mb-7.5 md:mb-12 text-1.5xl md:text-4xl lg:text-5xl break-keep"
          >
            함께 하고 있는 <span style={{ color: ColorMainBlue }}>병원</span>
            입니다.
          </Text>
          <PartnerWrap>
            <PartnerList>
              {partnerLogos.map((logo, idx) => (
                <PartnerItem key={`partner-logo-${idx + 1}`}>
                  <img src={logo} alt={`병원 로고 ${idx + 1}`} />
                </PartnerItem>
              ))}
            </PartnerList>
          </PartnerWrap>
        </Container>
      </Wrapper>
    </>
  );
}

const Wrapper = styled.div`
  padding: 60px 0 120px;
  background-color: ${ColorBgGray};

  @media all and (max-width: 767px) {
    padding: 30px 0;
  }
`;
const PartnerWrap = styled.div`
`;
const PartnerList = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 24px 32px;

  @media all and (max-width: 1023px) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 20px;
  }

  @media all and (max-width: 767px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
  }
`;
const PartnerItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 72px;
  padding: 10px 14px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  background-color: #fff;

  img {
    width: 100%;
    max-width: 160px;
    max-height: 52px;
    object-fit: contain;
  }

  @media all and (max-width: 767px) {
    min-height: 64px;
    padding: 10px 12px;

    img {
      max-width: 140px;
      max-height: 44px;
    }
  }
`;

export default MainPartner;
